export const FETCH_STATE_IS_AUTHORIZED = "FETCH_STATE_IS_AUTHORIZED";
export const RESET_STATE_IS_AUTHORIZED = "RESET_STATE_IS_AUTHORIZED";
